import { Box, Typography } from "@mui/material";
import styled from "styled-components";
import { SubSectionContainerText } from "components/SubSection/SubSection.styled";
import { ImageElement, ImageContainer } from "components/Image/Image.styled";
import { ButtonContainer } from "components/Button/ActionButton/ActionButton.styled";
import { Highlight } from "components/Hightlight/Hightlight.style";

export const CaseStudyBannerContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  font-weight: 400;
  margin-bottom: 120px;

  @media (max-width: 1170px) {
    padding: 0;
    justify-content: center;
    margin-bottom: 32px;

    & ${ButtonContainer} {
      max-width: none;
    }
  }
`;
export const CaseStudyBannerParagraph = styled(Box)`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  max-width: 518px;
`;
export const CaseStudyBannerParagraphHeader = styled(Box)`
  font-size: 72px;
  font-stretch: expanded;
  letter-spacing: -1px;
  color: ${(props) => props?.theme.colors?.dark};
  white-space: pre-line;

  @media (max-width: 1170px) {
    font-size: 28px;
  }
`;
export const CaseStudyBannerParagraphText = styled(Box)`
  color: ${(props) => props?.theme.colors?.headerColor};
  & ${SubSectionContainerText} {
    margin: 12px 0px 34px 0;
  }

  & ${Highlight} {
    font-stretch: normal;
    background-color: ${(props) =>
      props.$highlightColor ?? props?.theme.colors.secondaryOpaque};
  }

  @media (max-width: 1170px) {
    & ${SubSectionContainerText} {
      font-size: 16px;
      line-height: 24px;
      margin: 10px 0;
      padding: 0 10px 0 0;
    }
    & ${Highlight} {
      line-height: 24px;
    }
  }
`;

export const CaseStudyBannerParagraphActions = styled(Box)`
  display: flex;
  gap: 27px;
  padding-bottom: 10px;
  padding-right: 10px;

  & a {
    flex-grow: 1;
    padding: 38px 32px;
    gap: 6px;
  }
`;

export const CaseStudyBannerImage = styled(Box)`
  background-image: url(${(props) => props.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  border-radius: 32px;
  width: 618px;
  height: 492px;

  @media (max-width: 1170px) {
    height: auto;
    width: 100vw;
    & ${ImageContainer}, & ${ImageElement}, & img {
      height: auto;
      width: 95%;
      margin: 0 0 -2px 0;
      border-radius: 0;
    }
  }
`;
export const Bold = styled.span`
  font-weight: 800;
  font-stretch: expanded;
`;

export const CaseStudyBadges = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
`;

export const CaseStudyBadge = styled(Typography)`
  border-radius: 16px;
  padding: 8px 16px;
  background-color: ${(props) => props?.theme.colors.dark};
  color: ${(props) => props?.theme.colors?.white};

  &:first-of-type {
    background-color: ${(props) =>
      props.$highlightColor ?? props?.theme.colors.secondaryOpaque};
    color: ${(props) => props?.theme.colors?.dark};
  }

  font-family: "Mona-Sans";
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
`;

export const BackButton = styled.a`
  padding: 132px 0 36px 0;
  color: ${(props) => props?.theme.colors.dark};
  font-family: "Mona-Sans";
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;

  vertical-align: middle;
  text-decoration: none;

  display: flex;
  align-items: center;
  gap: 6px;
  svg {
    margin-right: 6px;
  }

  @media (max-width: 1170px) {
    padding: 76px 0 24px 0;
  }
`;
